import axios from 'axios';
import {backendHost} from '../../config';

export const getCampaign = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/campaign`, {params});
};